import { api, formatApiErrorDetail } from "./api";

export async function auditQuick(prompt, language) {
  try {
    const { data } = await api.post("/audit/quick", { prompt, language });
    return { ok: true, data };
  } catch (e) {
    return { ok: false, status: e.response?.status, body: e.response?.data, message: formatApiErrorDetail(e.response?.data?.detail) || e.message };
  }
}

export async function auditDeep(prompt, language) {
  try {
    const { data } = await api.post("/audit/deep", { prompt, language });
    return { ok: true, data };
  } catch (e) {
    return { ok: false, status: e.response?.status, body: e.response?.data, message: formatApiErrorDetail(e.response?.data?.detail) || e.message };
  }
}
